module.exports = __webpack_public_path__ + "static/media/sc_10_i.3ec5c3c9.png";